import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    score_details: {},
    plan_details: {},
    assessment_details:{},
};

const paidAssessmentReducer = createSlice({
    name: "paidAssessmentReducer",
    initialState,
    reducers: {
        setScoreDetail(state, action) {
            state.score_details = action.payload;
        },
        setPlanDetail(state, action) {
            state.plan_details = action.payload;
        },
        setAssessmentDetails(state, action) {
            state.assessment_details = action.payload;
        },
        resetPaidAssessment(state, action) {
            state.assessment_details = {};
            state.assessment_details = {};
            state.score_details = {};
        },
    },
});
export const { setScoreDetail, setPlanDetail,setAssessmentDetails,resetPaidAssessment } = paidAssessmentReducer.actions;
export default paidAssessmentReducer.reducer;